<div class="header">
  <app-logo></app-logo>
  <app-navigation></app-navigation>
  <app-nav-buttons></app-nav-buttons>
</div>

